import { CustomColumn } from 'baseui/data-table';

import { CustomDateColumn } from 'commons-ui';
import { useDataFormatter } from '../showChanges/helper';

export const COL_NAMES = {
	buckets: 'buckets',
	createdAt: 'createdAt'
};

export const columnConfigs = [
	CustomColumn({
		title: 'Buckets',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.buckets],
		renderCell: (data: any) => {
			const { renderBuckets } = useDataFormatter();
			const { value } = data;
			return renderBuckets(value);
		}
	}),
	CustomDateColumn({
		title: 'Created at',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	})
];
